module.exports = __webpack_public_path__ + "img/20200510_122902.f1088fc3.jpg";